import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 0 83px;
  @media screen and (max-width: 1200px) {
    padding: 0 33px;
  }
`;
